import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import classes from './DaySettingReadOnly.css';

function DaySettingReadOnly(props) {

    if (props.dayData != null) {
        return (
            <Row className={classes.DaySettingReadOnlyRow}>
                <Col>{props.day}</Col>
                <Col>{props.dayData.from}:00 to {props.dayData.to}:00</Col>
            </Row>
        );
    }
    
    else {
        return (
            <Row className={classes.DaySettingReadOnlyRow}>
                <Col>{props.day}</Col>
                <Col> Not Available </Col>
            </Row>
        );
    }
}

export default DaySettingReadOnly;


// WEBPACK FOOTER //
// ./src/containers/Profile/Setting/ScheduleRead/DaySettingReadOnly/DaySettingReadOnly.js